import React, { Component } from 'react';
import { Parallax } from 'react-skrollr';
import { multiLanguage } from '../../hoc';
import { Slider } from '../../components';

const imageSlider = [
  { image: 'https://lagunaproperty.com/images/invi1.jpg' },
  { image: 'https://lagunaproperty.com/images/invi2.jpg' },
  { image: 'https://lagunaproperty.com/images/invi3.jpg' },
  { image: 'https://lagunaproperty.com/images/invi4.jpg' },
  { image: 'https://lagunaproperty.com/images/invi5.jpg' },
  { image: 'https://lagunaproperty.com/images/invi6.jpg' }
];

@multiLanguage()
export default class Section6 extends Component {
  render() {
    return (
      <div className="section6">
        <div class="content">
          <h3>Invitations to join Xperential Guest Programme</h3>
          <p>Pre-opening, trial stays at new resorts</p>
        </div>
        <div className="image-slider-block">
          <div className="parallax-container">
            <Parallax
              data={{
                'data-86-bottom-top': 'transform: translateY(-100px); filter: blur(300px) saturate(2);',
                'data-250-top': 'transform: translateY(0px); filter: blur(0px) saturate(1);'
              }}
            >
              <Slider
                type="type-background"
                sliderRef={this.sliderRef}
                items={imageSlider}
                settings={{ arrows: false }}
                uiRenderer={(item, index) => {
                  return (
                    <div
                      className="img-background"
                      style={{
                        backgroundImage: `url(${item.image})`,
                        backgroundPosition: item.backgroundPosition
                      }}
                    />
                  );
                }}
              />
            </Parallax>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SanctuaryClub/Section6.js